import EscapeFromTarkov01Thumb from './images/escape-from-tarkov-01-thumb.webp'
import EscapeFromTarkov01 from './images/escape-from-tarkov-01.webp'
import EscapeFromTarkov02Thumb from './images/escape-from-tarkov-02-thumb.webp'
import EscapeFromTarkov02 from './images/escape-from-tarkov-02.webp'
import EscapeFromTarkov03Thumb from './images/escape-from-tarkov-03-thumb.webp'
import EscapeFromTarkov03 from './images/escape-from-tarkov-03.webp'
import EscapeFromTarkov04Thumb from './images/escape-from-tarkov-04-thumb.webp'
import EscapeFromTarkov04 from './images/escape-from-tarkov-04.webp'
import EscapeFromTarkov05Thumb from './images/escape-from-tarkov-05-thumb.webp'
import EscapeFromTarkov05 from './images/escape-from-tarkov-05.webp'
import EscapeFromTarkov06Thumb from './images/escape-from-tarkov-06-thumb.webp'
import EscapeFromTarkov06 from './images/escape-from-tarkov-06.webp'
import EscapeFromTarkovBanner from './images/escape-from-tarkov-banner.webp'
import WorldOfWarships01Thumb from './images/world-of-warships-01-thumb.webp'
import WorldOfWarships01 from './images/world-of-warships-01.webp'
import WorldOfWarships02Thumb from './images/world-of-warships-02-thumb.webp'
import WorldOfWarships02 from './images/world-of-warships-02.webp'
import WorldOfWarships03Thumb from './images/world-of-warships-03-thumb.webp'
import WorldOfWarships03 from './images/world-of-warships-03.webp'
import WorldOfWarships04Thumb from './images/world-of-warships-04-thumb.webp'
import WorldOfWarships04 from './images/world-of-warships-04.webp'
import WorldOfWarships05Thumb from './images/world-of-warships-05-thumb.webp'
import WorldOfWarships05 from './images/world-of-warships-05.webp'
import WorldOfWarships06Thumb from './images/world-of-warships-06-thumb.webp'
import WorldOfWarships06 from './images/world-of-warships-06.webp'
import WorldOfWarships07Thumb from './images/world-of-warships-07-thumb.webp'
import WorldOfWarships07 from './images/world-of-warships-07.webp'
import WorldOfWarshipsBanner from './images/world-of-warships-banner.webp'

export type SteamVerdict =
    | 'overwhelminglyPositive'
    | 'veryPositive'
    | 'positive'
    | 'mostlyPositive'
    | 'mixed'
    | 'mostlyNegative'
    | 'negative'
    | 'veryNegative'
    | 'overwhelminglyNegative'

export type SteamGameId = 'world-of-warships' | 'escape-from-tarkov'

export type SteamScreenshot = {
    full: string
    thumb: string
}

type SteamReview = {
    verdict: SteamVerdict
    count: string
}

export type SteamGame = {
    id: SteamGameId
    name: string
    tags: string[]
    storeUrl: string
    banner: string
    screenshots: SteamScreenshot[]
    englishReviews: SteamReview
    recentReviews: SteamReview
}

export const STEAM_GAMES: SteamGame[] = [
    {
        id: 'world-of-warships',
        name: 'World of Warships',
        tags: ['MMO', 'Online PvP', 'English +45'],
        storeUrl: 'https://store.steampowered.com/app/552990/World_of_Warships/',
        banner: WorldOfWarshipsBanner,
        screenshots: [
            { full: WorldOfWarships01, thumb: WorldOfWarships01Thumb },
            { full: WorldOfWarships02, thumb: WorldOfWarships02Thumb },
            { full: WorldOfWarships03, thumb: WorldOfWarships03Thumb },
            { full: WorldOfWarships04, thumb: WorldOfWarships04Thumb },
            { full: WorldOfWarships05, thumb: WorldOfWarships05Thumb },
            { full: WorldOfWarships06, thumb: WorldOfWarships06Thumb },
            { full: WorldOfWarships07, thumb: WorldOfWarships07Thumb },
        ],
        englishReviews: { verdict: 'veryPositive', count: '49,093' },
        recentReviews: { verdict: 'mixed', count: '607' },
    },
    {
        id: 'escape-from-tarkov',
        name: 'Escape from Tarkov',
        tags: ['MMO', 'Online PvP', 'English +20'],
        storeUrl: 'https://store.steampowered.com/app/3932890/Escape_from_Tarkov/',
        banner: EscapeFromTarkovBanner,
        screenshots: [
            { full: EscapeFromTarkov01, thumb: EscapeFromTarkov01Thumb },
            { full: EscapeFromTarkov02, thumb: EscapeFromTarkov02Thumb },
            { full: EscapeFromTarkov03, thumb: EscapeFromTarkov03Thumb },
            { full: EscapeFromTarkov04, thumb: EscapeFromTarkov04Thumb },
            { full: EscapeFromTarkov05, thumb: EscapeFromTarkov05Thumb },
            { full: EscapeFromTarkov06, thumb: EscapeFromTarkov06Thumb },
        ],
        englishReviews: { verdict: 'mixed', count: '11,885' },
        recentReviews: { verdict: 'mixed', count: '3,511' },
    },
]
